import React from "react";
import { useHistory } from "react-router-dom";
import QbaceLogo from "../../assets/images/image/QbaceLogo.svg";

const NotFound = () => {
  const history = useHistory();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        background: "#F5F7FA",
        fontFamily: "Manrope",
      }}
    >
      <img src={QbaceLogo} alt="QBace" style={{ height: "36px", marginBottom: "40px" }} />

      <div
        style={{
          fontSize: "96px",
          fontWeight: "800",
          color: "#006AFF",
          lineHeight: 1,
        }}
      >
        404
      </div>

      <div
        style={{
          fontSize: "22px",
          fontWeight: "700",
          color: "#031227",
          marginTop: "16px",
        }}
      >
        Page not found
      </div>

      <div
        style={{
          fontSize: "14px",
          color: "#9AA0A9",
          marginTop: "8px",
          textAlign: "center",
          maxWidth: "360px",
        }}
      >
        The page you're looking for doesn't exist or has been moved.
      </div>

      <button
        onClick={() => history.push("/home/dashboard")}
        style={{
          marginTop: "32px",
          padding: "10px 28px",
          background: "#006AFF",
          color: "#fff",
          border: "none",
          borderRadius: "8px",
          fontSize: "14px",
          fontWeight: "600",
          cursor: "pointer",
        }}
      >
        Go to Dashboard
      </button>
    </div>
  );
};

export default NotFound;
